export const normalizeTitle = (title: string): string => {
  const specialTitles: Record<string, string> = {
    "A Working Man": "A Working Man",
    "The Bondsman : Le Diable en Prime": "The Bondsman: Le Diable en Prime",
    "Demain est un autre jour": "Demain est un autre jour",
    "Carjackers": "Carjackers",
    "Minecraft, le film": "Minecraft: Le Film"
  };

  return specialTitles[title] || title;
};
